import { useStore } from '../useStore';
import { stores } from '../../stores';
import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { getStoreValue } from '../../stores/store/utils';
import { useGlobalModal } from '../useGlobalModal';
import SportBetslipV2ClearAllModal from '../../components/sport/betslip-v-2/clear-all-modal/SportBetslipV2ClearAllModal';

export function useAcceptAnyOddsChanges() {
    const [userState, setUserState] = useStore(stores.sports.betSlipUserState);
    const { acceptAnyOddsChanges } = userState;

    function setAcceptAnyOddsChanges(value: boolean) {
        setUserState((state) => ({ ...state, acceptAnyOddsChanges: value }));
    }

    return {
        acceptAnyOddsChanges,
        setAcceptAnyOddsChanges,
    };
}

export function useKeptMySelectionSettings() {
    const [keptBetslipSelections, setKeptBetslipSelections] = useStore(stores.sports.keptBetslipSelections);
    const [betSlipMarketIdToOutcomeId, setBetSlipMarketIdToOutcomeId] = useStore(
        stores.sports.betSlipMarketIdToOutcomeId,
    );

    useEffect(restoreSelections, []);

    useEffect(() => {
        if (isEmpty(betSlipMarketIdToOutcomeId) || isEmpty(keptBetslipSelections)) {
            return;
        }
        setKeptBetslipSelections(betSlipMarketIdToOutcomeId);
    }, [betSlipMarketIdToOutcomeId]);

    function updateKeptBetslipSelectionsValue(value: boolean) {
        setKeptBetslipSelections(value ? betSlipMarketIdToOutcomeId : null);
    }

    function restoreSelections() {
        const keptSelections = getStoreValue(stores.sports.keptBetslipSelections);
        if (!keptSelections) {
            return;
        }
        setBetSlipMarketIdToOutcomeId(keptSelections);
    }

    return {
        keptBetslipSelections,
        updateKeptBetslipSelectionsValue,
    };
}

export function useClearAllModal() {
    const { showModal, hideModal } = useGlobalModal();

    function show(onAccept: () => void) {
        showModal(SportBetslipV2ClearAllModal, {
            params: {
                onDismiss: hideModal,
                onAccept: () => {
                    onAccept();
                    hideModal();
                },
            },
            onClose: hideModal,
            mode: 'default',
        });
    }

    return {
        show,
    };
}
